const cliente = {
  readClienteAlumno: '{{uuid_academia}}/cliente-persona/{{uuid_venta}}',
  updateClienteAlumno: '{{uuid_academia}}/cliente-persona/{{uuid_venta}}'
}

export default cliente
